import { Link } from "react-router-dom";
import { euro } from "@/lib/api";
import { Cpu, Network, Server, Package, ArrowRight } from "lucide-react";

const catIcon = {
  "AI Software": Cpu,
  "Network Tools": Network,
  "Computer Software": Server,
  "Digital Products": Package,
};

export default function ProductCard({ product, index = 0 }) {
  const Icon = catIcon[product.category] || Package;
  return (
    <div className="tactical-card p-6 flex flex-col fade-up" style={{ animationDelay: `${index * 60}ms` }}
      data-testid={`product-card-${product.id}`}>
      <div className="flex items-start justify-between mb-5">
        <div className="w-12 h-12 rounded-xl bg-[#0A0E1A] border border-[#1E2F4D] flex items-center justify-center">
          <Icon className="w-6 h-6 text-cyan-400" />
        </div>
        <span className="inline-flex items-center px-2.5 py-1 rounded-full text-[10px] font-mono font-medium bg-blue-500/10 text-blue-400 border border-blue-500/30">
          {product.category}
        </span>
      </div>
      <h3 className="font-display text-lg font-bold text-white leading-snug mb-2">{product.title}</h3>
      <p className="text-sm text-slate-400 leading-relaxed flex-1">{product.tagline}</p>
      <div className="flex items-center justify-between mt-6 pt-5 border-t border-[#1E2F4D]">
        <div>
          <span className="block text-[10px] font-mono uppercase tracking-widest text-slate-500">Licence</span>
          <span className="font-display text-2xl font-extrabold text-white">{euro(product.price)}</span>
        </div>
        <Link to={`/products/${product.id}`}
          className="inline-flex items-center gap-1.5 bg-[#2563EB] hover:bg-[#1D4ED8] btn-glow text-white text-sm font-semibold px-4 py-2.5 rounded-full"
          data-testid={`view-product-${product.id}`}>
          View <ArrowRight className="w-4 h-4" />
        </Link>
      </div>
    </div>
  );
}
